import { render, staticRenderFns } from "./IncomeForm.vue?vue&type=template&id=451a8aea&lang=pug&"
import script from "./IncomeForm.vue?vue&type=script&lang=js&"
export * from "./IncomeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports